export default __webpack_public_path__ + "static/media/weee.36ddbdf6.svg";